import { ca } from '@cian/analytics';

import { MORTGAGE_PROMO_TYPES } from '../../../constants/promos';
import { getProductsData } from '../../../selectors/analytics';
import { IPromo } from '../../../types/newbuilding/promos';

export function trackShowPhone(customPageURL: string, promo: IPromo, newbuildingId: number) {
  const { promoType, promoId } = promo;

  const isMortgage = MORTGAGE_PROMO_TYPES.includes(promo.promoType);

  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action: isMortgage ? 'Open_jk_mortgage' : 'Open_jk_promotions',
    label: customPageURL,
    products: [getProductsData(newbuildingId, null, { label: promoType, promotion_id: promoId })],
  });
}
